<a [href]="baseCategoryRoute" class="my-0" shrdUicButton variant="tertiaryMinorBorderless">
  <shrd-uic-svg-icon icon="show-pass" />
  <span>{{ 'header.navigation.detailedView' | i18next }}</span>
</a>
